import intellegenceService from "../shared/services/intellegenceService";
import getDates from "../shared/services/date.service";
import { setLogout } from "./authActions";

const REQUEST_SPEEDING_POINTS = "REQUEST_SPEEDING_POINTS";
const RESPONSE_SPEEDING_POINTS = "RESPONSE_SPEEDING_POINTS";
const REQUEST_SPEEDING_POINTS_FAILURE = "REQUEST_SPEEDING_POINTS_FAILURE";
const CLEAR_SPEEDING_POINTS = "CLEAR_SPEEDING_POINTS";

const requestSpeedingPointsAction = () => {
  return {
    type: REQUEST_SPEEDING_POINTS,
  };
};

const responseSpeedingPointsAction = (data) => {
  return {
    type: RESPONSE_SPEEDING_POINTS,
    data,
  };
};

const requestSpeedingPointsFailureAction = (errors) => {
  return {
    type: REQUEST_SPEEDING_POINTS_FAILURE,
    errors,
  };
};

const getSpeedingPoints = (options) => {
  const startDate = getDates.fixISOStringDateToPost(options.startDate);
  const endDate = getDates.fixISOStringDateToPost(options.endDate);

  return (dispatch) => {
    dispatch(requestSpeedingPointsAction());

    intellegenceService
      .getSpeedingPoints(options.carId, {
        startDate,
        endDate,
        timeZone: (new Date().getTimezoneOffset() / 60) * -1,
      })
      .then((result) => {
        dispatch(responseSpeedingPointsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestSpeedingPointsFailureAction(error.response));

        if (error.response && error.response.status === 401) {
          dispatch(setLogout());
        }
      });
  };
};

const clearSpeedingPointsAction = () => {
  return {
    type: CLEAR_SPEEDING_POINTS,
  };
};

export {
  REQUEST_SPEEDING_POINTS,
  RESPONSE_SPEEDING_POINTS,
  REQUEST_SPEEDING_POINTS_FAILURE,
  CLEAR_SPEEDING_POINTS,
  getSpeedingPoints,
  clearSpeedingPointsAction,
};
